var MapAddressModule = /** @class */ (function () {
    function MapAddressModule() {
    }
    return MapAddressModule;
}());
export { MapAddressModule };
